
import { mapState } from "vuex";

import PdpTrueMattressesOnly from "./PdpTrueMattressesOnly";
import PdpTrueBeds from "./PdpTrueBeds";
import PdpBedsideTables from "./PdpBedsideTables";
import PdpLowboys from "./PdpLowboys";
import PdpMirrors from "./PdpMirrors";
import PdpTallboys from "./PdpTallboys";
import PdpDesks from "./PdpDesks";
import PdpBlanketBoxes from "./PdpBlanketBoxes";
import PdpDresserWithMirror from "./PdpDresserWithMirror.vue";
import PdpDresserWithoutMirror from "./PdpDresserWithoutMirror.vue";
import PdpBookcases from "./PdpBookcases";
import PdpDefaultPlaceholder from "./PdpDefaultPlaceholder";

import tagableMixin from "~/mixins/tagableMixin";
import { camelize } from "~/utils";

// compted tags should be mutually exclusive
// i.e. only one should be existing for a particular product
const computedTagNames = [
  "true-mattresses-only",
  "true-beds",
  "bedside-tables",
  "lowboys",
  "mirrors",
  "tallboys",
  "desks",
  "blanket-boxes",
  "bookcases",
  "dresser-with-mirror",
  "dresser-without-mirror",
];

export default {
  components: {
    PdpTrueMattressesOnly,
    PdpTrueBeds,
    PdpBedsideTables,
    PdpLowboys,
    PdpMirrors,
    PdpTallboys,
    PdpDesks,
    PdpBlanketBoxes,
    PdpBookcases,
    PdpDefaultPlaceholder,
    PdpDresserWithMirror,
    PdpDresserWithoutMirror,
  },

  mixins: [tagableMixin],

  props: {
    width: { type: String, default: "" },
    height: { type: String, default: "" },
    depth: { type: String, default: "" },
    variantWeight: { type: String, default: "" },
    tags: { type: Array, default: () => [] },
    dimensionsIcon: { type: Object, default: null },
  },

  computed: {
    ...mapState(["siteConfig"]),
    trueMattressesOnly() {
      return this.mattressesOnly && (!this.headboards || !this.sofaBeds);
    },
    trueBeds() {
      return this.beds && (!this.headboards || !this.sofaBeds);
    },
    tagName() {
      return computedTagNames.find(name => this?.[camelize(name, false)]);
    },
    componentName() {
      return this.tagName
        ? `Pdp${camelize(this.tagName)}`
        : "PdpDefaultPlaceholder";
    },
    dimHeight() {
      return this.tagName ? `dim-height-${this.tagName}` : "dim-height";
    },
    dimWidth() {
      return this.tagName ? `dim-width-${this.tagName}` : "dim-width";
    },
    dimDepth() {
      return this.tagName ? `dim-depth-${this.tagName}` : "dim-depth";
    },
  },
};
